import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Phone, Menu, X } from 'lucide-react';
import { MobileMenu } from './MobileMenu';
import { AnimatePresence } from 'framer-motion';

export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
          isScrolled || isMobileMenuOpen ? 'bg-white/95 backdrop-blur-md shadow-sm border-slate-100 py-3' : 'bg-white/80 backdrop-blur-sm border-transparent py-4'
        }`}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
          
          {/* Logo Area */}
          <div className="flex items-center gap-2 cursor-pointer relative z-50" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center shadow-sm transition-colors ${isMobileMenuOpen ? 'bg-brand-800' : 'bg-brand-800'}`}>
              <span className="text-white font-bold text-lg">L</span>
            </div>
            <span className={`font-semibold text-lg tracking-tight ${isMobileMenuOpen ? 'text-slate-900' : 'text-slate-900'}`}>
              LetselHulp Direct
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <nav className="flex items-center gap-6 mr-4">
              <button onClick={() => document.getElementById('schadecheck')?.scrollIntoView({behavior: 'smooth'})} className="text-sm font-medium text-slate-600 hover:text-brand-700 transition-colors">
                Schadecheck
              </button>
              <button onClick={() => document.getElementById('contact')?.scrollIntoView({behavior: 'smooth'})} className="text-sm font-medium text-slate-600 hover:text-brand-700 transition-colors">
                Werkwijze
              </button>
            </nav>
            
            <a href="tel:0201234567" className="flex items-center gap-2 text-slate-800 hover:text-brand-700 transition-colors font-medium">
              <Phone size={16} className="text-brand-600" />
              <span className="text-sm">020 - 123 45 67</span>
            </a>

            <div className="h-6 w-px bg-slate-200 mx-2"></div>

            <Button 
              size="sm" 
              variant="primary"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Gratis intake
            </Button>
          </div>

          {/* Mobile Actions */}
          <div className="flex items-center gap-2 md:hidden relative z-50">
            {/* Direct Call Button (High Intent) - Only visible when menu closed */}
            {!isMobileMenuOpen && (
              <a href="tel:0201234567" className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-50 text-slate-700 active:bg-slate-200 transition-colors">
                <Phone size={18} />
              </a>
            )}

            {/* Primary CTA - Only visible when menu closed */}
            {!isMobileMenuOpen && (
              <Button 
                size="sm" 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Intake
              </Button>
            )}

            {/* Menu Toggle */}
            <Button
              variant="icon"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="ml-1"
              aria-label={isMobileMenuOpen ? "Sluit menu" : "Open menu"}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </Button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </>
  );
};